/**
 * The Dispatch Stock Transfer – Plant list. Its own static route: this form is not an arrival and
 * does not use the arrival list.
 */
import { TRANSFER_TABS } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { TransferListPage } from "@/features/dispatch-stock-transfer/components/transfer-list-page";

const search = z.object({
  tab: z.enum(TRANSFER_TABS).default("draft"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
  view: z.enum(["transit"]).optional(),
});

export const Route = createFileRoute("/_app/dispatch/stock-transfer/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <TransferListPage
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
